export type DueState = 'on_time' | 'due_soon' | 'overdue' | 'none'

export type Urgency = 'err' | 'wait' | 'idle'

const DUE_STATES: readonly DueState[] = ['none', 'on_time', 'due_soon', 'overdue']

const URGENCY: Record<DueState, Urgency> = { overdue: 'err', due_soon: 'wait', on_time: 'idle', none: 'idle' }

export function parseDueState(raw: unknown): DueState {
  return DUE_STATES.includes(raw as DueState) ? (raw as DueState) : 'none'
}

export function urgencyOf(state: DueState | null | undefined): Urgency {
  return URGENCY[parseDueState(state)]
}

export function worstDueState(current: DueState, next: DueState): DueState {
  return DUE_STATES.indexOf(next) > DUE_STATES.indexOf(current) ? next : current
}

export interface RequestDueRow {
  is_terminal?: boolean
  is_late?: boolean
  days_remaining?: number | null
  due_state?: DueState | null
}

type Translate = (key: string, params?: Record<string, unknown>) => string

export function requestDueLabel(row: RequestDueRow, t: Translate): string {
  if (row.is_terminal) return t(row.is_late ? 'requests.table.closedLate' : 'requests.table.closedOnTime')
  const days = row.days_remaining
  if (days === null || days === undefined) return ''
  if (days === 0) return t(parseDueState(row.due_state) === 'overdue' ? 'requests.table.overdueToday' : 'requests.table.dueToday')
  if (days > 0) return days === 1 ? t('requests.table.dueInOneDay') : t('requests.table.dueInDays', { count: days })
  const overdueDays = Math.abs(days)
  if (overdueDays > 60) return t('requests.table.overdueMonths', { count: Math.round(overdueDays / 30) })
  return overdueDays === 1 ? t('requests.table.overdueOneDay') : t('requests.table.overdueDays', { count: overdueDays })
}
